import {
  RefineGroupType,
  RefineOptionType,
  FilterByTypeType,
  RefineGroupKeyType,
  SloFiltersType,
  CapabilityFiltersType,
} from './types';

export const testIds = {
  advancedSearch: 'advanced-search',
  searchBoxInput: 'search-box-input',
  searchPagination: 'search-pagination',
  searchBoxInputSpinner: 'search-box-input-spinner',
  searchBoxInputClear: 'search-box-input-clear',
  searchStatusBar: 'search-status-bar',
  searchRefiner: 'search-refiner',
  searchNotApplied: 'search-not-applied',
  searchResults: 'search-results',
  searchResultListTitleBreachIcon: 'search-results-list-title-breach-icon',
  searchResultListTitleMeetIcon: 'search-results-list-title-meet-icon',
  searchResultListTitleIssueIcon: 'search-results-list-title-issue-icon',
  searchResultListTitleCount: 'search-results-list-title-count',
  searchResultListTitleAction: 'search-results-list-title-action',
  searchResultListContentBasic: 'search-results-list-content-basic',
  searchResultSummaryTotalBadge: 'search-results-summary-total-badge',
};

export const refineGroups: RefineGroupType[] = [
  {
    label: 'filter by type',
    key: RefineGroupKeyType.FilterByType,
    options: [
      {
        label: 'SLO Groups',
        key: FilterByTypeType.BySloGroup,
        helperCopyPath: 'refiner.sloGroup',
      },
      {
        label: 'SLOs',
        key: FilterByTypeType.BySlo,
        options: [
          { label: 'Breaching only', key: SloFiltersType.BreachingOnly },
          { label: 'Draft only', key: SloFiltersType.DraftOnly },
        ],
      },
      {
        label: 'Capabilities',
        key: FilterByTypeType.ByCapability,
        options: [
          { label: 'With SLO breach only', key: CapabilityFiltersType.WithSloBreachOnly },
          { label: 'With no SLOs only', key: CapabilityFiltersType.WithNoSloOnly },
        ],
      },
      { label: 'Teams', key: FilterByTypeType.ByTeam },
      { label: 'Products', key: FilterByTypeType.ByProduct },
    ],
  },
  /*
  {
    label: 'slo filters',
    key: RefineGroupKeyType.SloFilters,
    options: [
      { label: 'Breaching only', key: SloFiltersType.BreachingOnly },
      { label: 'Draft only', key: SloFiltersType.DraftOnly },
    ],
  },
  {
    label: 'capability filters',
    key: RefineGroupKeyType.CapabilityFilters,
    options: [
      { label: 'With SLO breaches only', key: CapabilityFiltersType.WithSloBreachOnly },
      { label: 'With no SLOs only', key: CapabilityFiltersType.WithNoSloOnly },
    ],
  },
  */
];

const filterByTypeOptions: RefineOptionType[] =
  refineGroups.find((x: RefineGroupType) => x.key === RefineGroupKeyType.FilterByType)?.options ||
  [];

export const filterByTypeOptionKeys = filterByTypeOptions.map((x: RefineOptionType) => x.key);

const sloOptions: RefineOptionType[] =
  filterByTypeOptions.find((x: RefineOptionType) => x.key === FilterByTypeType.BySlo)?.options ||
  [];
export const sloFilterOptionKeys = sloOptions.map((x: RefineOptionType) => x.key);

const capabilityOptions: RefineOptionType[] =
  filterByTypeOptions.find((x: RefineOptionType) => x.key === FilterByTypeType.ByCapability)
    ?.options || [];
export const capabilityFilterOptionKeys = capabilityOptions.map((x: RefineOptionType) => x.key);
